import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { faqs } from '../data/mock';

const FAQ = () => {
  return (
    <section id="faq" className="bg-gradient-to-b from-white to-blue-50" style={{ paddingTop: '80px', paddingBottom: '80px' }}>
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 leading-tight mx-auto"
            style={{ 
              maxWidth: '24ch',
              textWrap: 'balance',
              WebkitTextWrap: 'balance'
            }}
          >
            Frequently Asked Questions
          </h2>
          <p 
            className="text-lg sm:text-xl text-gray-600 leading-relaxed mx-auto"
            style={{ 
              maxWidth: '48ch',
              textWrap: 'balance',
              WebkitTextWrap: 'balance'
            }}
          >
            Everything you need to know about flight compensation
          </p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="bg-white rounded-xl border border-gray-200 px-6 sm:px-8 hover:border-blue-300 hover:shadow-md transition-all duration-300"
            >
              <AccordionTrigger className="text-left font-semibold text-base sm:text-lg text-gray-900 hover:text-blue-600 py-6">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-700 leading-relaxed pb-6 text-sm sm:text-base">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
